/**
 * 受注生産
 * 
 * 【設定値】
 * メタフィールド
 *  ・product.metafields.custom.is_made_to_order // 受注生産か否か（Boolean）
 * テーマ設定
 *  ・受注生産（販売開始日）
 *  ・受注生産（販売期間外のテキスト）
 * 
 * 現在時刻が受注生産販売「期間外」であれば、カートに追加ボタンを非表示にし、販売期間外テキストを表示
 * 現在時刻が受注生産販売「期間内」であれば、カートに追加ボタンを表示し、販売期間外テキストを非表示
 */
(() => {
  const madeToOrderInfoElement = document.getElementById('q-js-madeToOrderInfo');
  if(!madeToOrderInfoElement) {
    return
  }

  const madeToOrderInfo = {
    isMadeToOrder: JSON.parse(madeToOrderInfoElement.dataset.is_made_to_order),
    start: {
      year: madeToOrderInfoElement.dataset.is_made_to_order_start_year,
      month: madeToOrderInfoElement.dataset.is_made_to_order_start_month,
      day: madeToOrderInfoElement.dataset.is_made_to_order_start_day,
      time: madeToOrderInfoElement.dataset.is_made_to_order_start_time,
    },
    end: {
      year: madeToOrderInfoElement.dataset.is_made_to_order_end_year,
      month: madeToOrderInfoElement.dataset.is_made_to_order_end_month,
      day: madeToOrderInfoElement.dataset.is_made_to_order_end_day,
      time: madeToOrderInfoElement.dataset.is_made_to_order_end_time,
    }
  }
  
  const now = new Date();
  const year = now.getFullYear();
  const month = String(now.getMonth() + 1).padStart(2, '0');
  const day = String(now.getDate()).padStart(2, '0');
  const hours = String(now.getHours()).padStart(2, '0');
  
  const date = {
    current: `${year}-${month}-${day}-${hours}`,
    salesStart: `${madeToOrderInfo.start.year}-${madeToOrderInfo.start.month}-${madeToOrderInfo.start.day}-${madeToOrderInfo.start.time}`,
    salesEnd: `${madeToOrderInfo.end.year}-${madeToOrderInfo.end.month}-${madeToOrderInfo.end.day}-${madeToOrderInfo.end.time}`
  }

  /**
   * "YYYY-MM-DD-HH" 形式を Date に変換するヘルパー関数
   */
  function parseTimeString(str) {
    const [y, m, d, h] = str.split('-').map(Number);
    // 月は0始まりなので -1
    return new Date(y, m - 1, d, h);
  }

  /**
   * 販売期間外
   */
  function onSalesPeriodInactive() {
    const madeToOrderMessageContainer = document.getElementById("q-js-isMadeToOrderMessageContainer");
    const buyButtonsContainer = document.getElementById("q-js-buyButtonsContainer");
    
    madeToOrderMessageContainer.classList.add('add-view');
    buyButtonsContainer.remove();
  }

  /**
   * 販売期間内
   */
  function onSalesPeriodActive() {
    const buyButtonsContainer = document.getElementById("q-js-buyButtonsContainer");
    
    buyButtonsContainer.classList.add('add-view');
  }

  /**
   * 販売期間内であれば callback() を実行する関数
   * @param {Object} date - 販売期間データ
   * @param {Function} callback - 販売期間内に行いたい処理
   */
  (()=> {
    // 各文字列を Date オブジェクトに変換
    const current = parseTimeString(date.current);
    const salesStart = parseTimeString(date.salesStart);
    const salesEnd = parseTimeString(date.salesEnd);

    // const isMadeToOrderClosed = madeToOrderInfo.isMadeToOrderClosed;

    // if(isMadeToOrderClosed === true) {
    //   onSalesPeriodInactive();
    //   console.log('強制販売終了');
    //   return
    // }

    if (current >= salesStart && current <= salesEnd) {
      onSalesPeriodActive();
    } else {
      onSalesPeriodInactive();
    }
  })(date, madeToOrderInfo);
})();
